<template>
  <div class="siblings-section">
    <div v-for="sibling in siblings" :key="sibling.APS_ID" class="sibling-row">
      <div class="sibling-field">
        <label>Name</label>
        <input class="form-control" type="text" v-model="sibling.APS_Name" readonly />
      </div>
      <div class="sibling-field sibling-field--small">
        <label>Gender</label>
        <input class="form-control" type="text" v-model="sibling.APS_Gender" readonly />
      </div>
      <div class="sibling-field">
        <label>Date of Birth</label>
        <input class="form-control" type="date" v-model="sibling.APS_DOB" readonly />
      </div>
      <div v-if="sibling.APS_PresentSchool" class="sibling-field">
        <label>Present School</label>
        <input class="form-control" type="text" v-model="sibling.APS_PresentSchool" readonly />
      </div>
      <div v-if="sibling.APS_PresentSchool === 'other'" class="sibling-field">
        <label>Other School</label>
        <input class="form-control" type="text" v-model="sibling.APS_OtherSchool" readonly />
      </div>
      <div v-if="sibling.APS_PresentSchool === 'notSchoolGoing'" class="sibling-field">
        <label>Age</label>
        <input class="form-control" type="text" v-model="sibling.APS_Age" readonly />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiblingsSection',
  props: {
    siblings: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.siblings-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sibling-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 2fr 2fr 1fr;
  gap: 1rem;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.sibling-field {
  display: flex;
  flex-direction: column;
}

.sibling-field--small {
  min-width: 100px;
}

.sibling-field label {
  font-weight: 500;
  margin-bottom: 5px;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
}

.form-control:readonly {
  background-color: #e9ecef;
  opacity: 1;
}

@media (max-width: 768px) {
  .sibling-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>
